import { Component, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IAppState } from 'app/store/app/app.state';
import { LogOut } from 'app/store/auth/auth.actions';
import { selectIsAuthenticated } from 'app/store/auth/auth.selectors';
import { userUtils } from 'app/store/users/users.utils';
import { map } from 'rxjs/operators';
import { SidebarService } from 'shared/services/sidebar.service';
import { isNullOrUndefined } from 'shared/utils/type.utils';
import { LABELS } from 'shared/consts/labels.const';


@Component({
  selector: 'app-sidebar-nav-user',
  templateUrl: './sidebar-nav-user.component.html',
  styleUrls: ['./sidebar-nav-user.component.scss'],
})
export class SidebarNavUserComponent {
  popOverOpen = false;
  isAuthenticated$ = this.store.pipe(select(selectIsAuthenticated));
  @Input() menuItemType: string = LABELS.MENU_TYPE_INFOPOST;

  userName$ = this.sidebarService
    .getUser$()
    .pipe(map(user => (isNullOrUndefined(user) ? '-' : userUtils.getUserName(user))));

  constructor(private sidebarService: SidebarService, private store: Store<IAppState>) { }

  togglePopover() {
    this.popOverOpen = !this.popOverOpen;
  }

  hidePopOver() {
    this.popOverOpen = false;
  }

  logout() {
    this.popOverOpen = false;
    console.error('User Logout clicked');
    this.store.dispatch(new LogOut(this.menuItemType === LABELS.MENU_TYPE_BISA ? LABELS.MENU_TYPE_BISA : ""));
  }
}
